import { Button, Text } from 'pcln-design-system';
import React from 'react';
export const InlineCitationLink = props => {
  var _a, _b;
  const {
    metadata
  } = props;
  return React.createElement(React.Fragment, null, (_b = (_a = metadata.citationNumber) === null || _a === void 0 ? void 0 : _a.split(',')) === null || _b === void 0 ? void 0 : _b.map((cn, index) => {
    return React.createElement(Button, {
      variation: 'link',
      key: `citation-link-${index}`,
      mx: 1,
      style: {
        transform: 'translateY(-5px)'
      }
    }, React.createElement(Text.span, {
      fontSize: '10px'
    }, cn));
  }));
};